import { z } from "zod";

export const stationMapSchema = z.object({
	station_id: z.string(),
	name_en: z.string(),
	name_ar: z.string(),
});
